/**
 * Helpers for preparing and validating client-graded module answer batches.
 * @module moduleAnswerSubmission
 */

import type { Question, UserAnswerSubmission } from '@/types/exam-simulation';

/**
 * Ensures every exam question has a prepared answer row before batch save.
 * Prevents recording a graded score when submissions were silently dropped.
 */
export function assertAnswerSubmissionsComplete(
  questions: Question[],
  answerSubmissions: UserAnswerSubmission[],
): void {
  if (questions.length === 0) {
    return;
  }
  if (answerSubmissions.length !== questions.length) {
    throw new Error(
      `Expected ${questions.length} answer submissions but prepared ${answerSubmissions.length}`,
    );
  }
}
